import {
  CreateOtherQaEquipmentDto,
  CreateOtherQaEquipmentDtoTypeEnum,
  CreatePtwQaEquipmentWithoutSerialNumberDto,
  CreatePtwQaEquipmentWithRegistrationDtoTypeEnum,
  CreatePtwQaEquipmentWithSerialNumberDto,
  CreatePtwQaEquipmentWithSerialNumberDtoTypeEnum,
  CreateQaEquipmentRtSystemDto,
  CreateUnicheckDeviceDto,
  CreateUnicheckDeviceDtoTypeEnum,
  CreateUnicheckSimulatorDto,
  CreateUnicheckSimulatorDtoTypeEnum,
  instanceOfOtherQaEquipmentDto,
  instanceOfPtwQaEquipmentWithoutSerialNumberDto,
  instanceOfPtwQaEquipmentWithRegistrationDto,
  instanceOfPtwQaEquipmentWithSerialNumberDto,
  instanceOfUnicheckDeviceDto,
  instanceOfUnicheckSimulatorDto,
  OtherQaEquipmentDto,
  PtwQaEquipmentWithoutSerialNumberDto,
  PtwQaEquipmentWithRegistrationDto,
  PtwQaEquipmentWithSerialNumberDto,
  QaEquipmentRtSystemDto,
  UnicheckDeviceDto,
  UnicheckSimulatorDto,
} from '@/api/generator';

function toCreateOtherQaEquipmentDto(
  qaEquipmentDto: OtherQaEquipmentDto,
): CreateOtherQaEquipmentDto {
  return {
    ...qaEquipmentDto,
    $type:
      CreateOtherQaEquipmentDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDeviceComponentDtoCreateOtherQaEquipmentDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toCreateUnicheckSimulatorDto(
  qaEquipmentDto: UnicheckSimulatorDto,
): CreateUnicheckSimulatorDto {
  return {
    ...qaEquipmentDto,
    $type:
      CreateUnicheckSimulatorDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDeviceComponentDtoCreateUnicheckSimulatorDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toCreateUnicheckDeviceDto(qaEquipmentDto: UnicheckDeviceDto): CreateUnicheckDeviceDto {
  return {
    ...qaEquipmentDto,
    $type:
      CreateUnicheckDeviceDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDeviceComponentDtoCreateUnicheckDeviceDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toCreatePtwQaEquipmentWithSerialNumberDto(
  qaEquipmentDto: PtwQaEquipmentWithSerialNumberDto,
): CreatePtwQaEquipmentWithSerialNumberDto {
  return {
    ...qaEquipmentDto,
    serialNumber: qaEquipmentDto.serialNumber,
    $type:
      CreatePtwQaEquipmentWithSerialNumberDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDeviceComponentDtoCreatePtwQaEquipmentWithSerialNumberDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toCreatePtwQaEquipmentWithoutSerialNumberDto(
  qaEquipmentDto: PtwQaEquipmentWithoutSerialNumberDto,
): CreatePtwQaEquipmentWithoutSerialNumberDto {
  return {
    ...qaEquipmentDto,
    $type:
      'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreatePtwQaEquipmentWithoutSerialNumberDto, Ptw.Ptw100.AppZero.Application.Shared',
  };
}

function toCreatePtwQaEquipmentWithRegistrationDto(
  qaEquipmentDto: PtwQaEquipmentWithRegistrationDto,
) {
  return {
    ...qaEquipmentDto,
    $type:
      CreatePtwQaEquipmentWithRegistrationDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDeviceComponentDtoCreatePtwQaEquipmentWithRegistrationDtoPtwPtw100AppZeroApplicationShared,
  };
}

export function toCreateDto(qaEquipmentDto: QaEquipmentRtSystemDto): CreateQaEquipmentRtSystemDto {
  if (instanceOfPtwQaEquipmentWithSerialNumberDto(qaEquipmentDto)) {
    return toCreatePtwQaEquipmentWithSerialNumberDto(
      qaEquipmentDto,
    ) as CreateQaEquipmentRtSystemDto;
  } else if (instanceOfPtwQaEquipmentWithoutSerialNumberDto(qaEquipmentDto)) {
    return toCreatePtwQaEquipmentWithoutSerialNumberDto(
      qaEquipmentDto,
    ) as CreateQaEquipmentRtSystemDto;
  } else if (instanceOfUnicheckDeviceDto(qaEquipmentDto)) {
    return toCreateUnicheckDeviceDto(qaEquipmentDto) as CreateQaEquipmentRtSystemDto;
  } else if (instanceOfUnicheckSimulatorDto(qaEquipmentDto)) {
    return toCreateUnicheckSimulatorDto(qaEquipmentDto) as CreateQaEquipmentRtSystemDto;
  } else if (instanceOfOtherQaEquipmentDto(qaEquipmentDto)) {
    return toCreateOtherQaEquipmentDto(qaEquipmentDto) as CreateQaEquipmentRtSystemDto;
  } else if (instanceOfPtwQaEquipmentWithRegistrationDto(qaEquipmentDto)) {
    return toCreatePtwQaEquipmentWithRegistrationDto(
      qaEquipmentDto,
    ) as CreateQaEquipmentRtSystemDto;
  } else {
    throw new Error('Unknown type of qaEquipmentDto');
  }
}
